import { mdiPiggyBank } from '@mdi/js';
import { Currency } from 'common/classes/currency';
import { BaseTable, ColumnProp } from 'common/components/table/base';
import { TableTitle } from 'common/components/table/title';
import useSelector from 'common/hooks/useSelector';
import { Wallet } from 'common/state/banking/actions';
import React, { useMemo } from 'react';

export const WalletsTable = () => {
  const { wallets } = useSelector((state) => state.wallets);

  const columns = useMemo(
    (): ColumnProp<Wallet>[] => [
      { key: 'title', title: 'Wallet' },
      { key: 'currency', title: 'Currency' },
      {
        key: 'balance',
        title: 'Balance',
        valueFormatter: (row) =>
          new Currency(row.balance, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.balance, row.currency).toString({ symbol: false }),
        sortValueGenerator: (row) => parseFloat(row.balance),
      },
      {
        key: 'credit',
        title: 'Credit',
        valueFormatter: (row) =>
          new Currency(row.credit, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.credit, row.currency).toString({ symbol: false }),
        sortValueGenerator: (row) => parseFloat(row.balance),
      },
      {
        key: 'deposit',
        title: 'Deposit',
        valueFormatter: (row) =>
          new Currency(row.deposit, row.currency).toElement(),
        csvFormatter: (row) =>
          new Currency(row.deposit, row.currency).toString({ symbol: false }),
        sortValueGenerator: (row) => parseFloat(row.balance),
      },
    ],
    []
  );

  return (
    <>
      <TableTitle icon={mdiPiggyBank} title="Wallets" />
      <BaseTable
        columns={columns}
        rows={wallets}
        csvName="Wallets"
        paginate={false}
      />
    </>
  );
};
